document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('open');
    });
  }
});
(function () {
  var overlay = document.getElementById('emailPopupOverlay');
  if (!overlay) return;

  var alreadySubscribed = localStorage.getItem('trawlrPopupSubscribed') === 'true';
  var alreadySeen = sessionStorage.getItem('trawlrPopupSeen') === 'true';

  function openPopup() {
    overlay.classList.add('open');
    sessionStorage.setItem('trawlrPopupSeen', 'true');
  }
  function closePopup() {
    overlay.classList.remove('open');
  }

  overlay.querySelectorAll('[data-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', closePopup);
  });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

  if (window.__trawlrJustSubscribed) {
    localStorage.setItem('trawlrPopupSubscribed', 'true');
    openPopup();
  } else if (!alreadySubscribed && !alreadySeen) {
    setTimeout(openPopup, 4000);
  }
})();

(function () {
  var targets = [];
    var main = document.getElementById('MainContent');
      if (main) {
          Array.prototype.forEach.call(main.children, function (el) {
                if (!el.querySelector('.hero')) {
                        el.classList.add('reveal');
                                targets.push(el);
                                      }
                                          });
                                            }
                                              var footer = document.querySelector('.site-footer');
                                                if (footer) {
                                                    footer.classList.add('reveal');
                                                        targets.push(footer);
                                                          }

                                                            if (!('IntersectionObserver' in window) || targets.length === 0) {
                                                                targets.forEach(function (el) { el.classList.add('is-visible'); });
                                                                    return;
                                                                      }

                                                                        var observer = new IntersectionObserver(function (entries) {
                                                                            entries.forEach(function (entry) {
                                                                                  if (entry.isIntersecting) {
                                                                                          entry.target.classList.add('is-visible');
                                                                                                  observer.unobserve(entry.target);
                                                                                                        }
                                                                                                            });
                                                                                                              }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

                                                                                                                targets.forEach(function (el) { observer.observe(el); });
                                                                                                                })();